/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_FailedInputs */

const th_video_failed = /** @type {(inputs: Video_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่สามารถถ่ายทอดสดได้`)
};

const en_video_failed = /** @type {(inputs: Video_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unable to broadcast`)
};

const ja_video_failed = /** @type {(inputs: Video_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`配信できません`)
};

const zh_video_failed = /** @type {(inputs: Video_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无法直播`)
};

const es_video_failed = /** @type {(inputs: Video_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se puede retransmitir`)
};

const pt_video_failed = /** @type {(inputs: Video_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não é possível transmitir`)
};

const id_video_failed = /** @type {(inputs: Video_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak bisa menyiarkan`)
};

const fr_video_failed = /** @type {(inputs: Video_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diffusion impossible`)
};

const tl_video_failed = /** @type {(inputs: Video_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi makapagsahimpapawid`)
};

const vi_video_failed = /** @type {(inputs: Video_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không phát được`)
};

const ko_video_failed = /** @type {(inputs: Video_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`중계할 수 없습니다`)
};

const de_video_failed = /** @type {(inputs: Video_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übertragung nicht möglich`)
};

const ru_video_failed = /** @type {(inputs: Video_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось транслировать`)
};

const tr_video_failed = /** @type {(inputs: Video_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yayınlanamadı`)
};

const it_video_failed = /** @type {(inputs: Video_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile trasmettere`)
};

const pl_video_failed = /** @type {(inputs: Video_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie udało się transmitować`)
};

const uk_video_failed = /** @type {(inputs: Video_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не вдалося транслювати`)
};

const hi_video_failed = /** @type {(inputs: Video_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रसारित नहीं हो सका`)
};

const ar_video_failed = /** @type {(inputs: Video_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تعذّر البث`)
};

const ms_video_failed = /** @type {(inputs: Video_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak dapat menyiarkan`)
};

const bn_video_failed = /** @type {(inputs: Video_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সম্প্রচার করা যায়নি`)
};

const zh_tw2_video_failed = /** @type {(inputs: Video_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無法轉播`)
};

const zh_hk2_video_failed = /** @type {(inputs: Video_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無法轉播`)
};

const ur_video_failed = /** @type {(inputs: Video_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نشر نہ ہو سکا`)
};

const fa_video_failed = /** @type {(inputs: Video_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`پخش ممکن نشد`)
};

const sw_video_failed = /** @type {(inputs: Video_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haikuweza kurusha`)
};

const nl_video_failed = /** @type {(inputs: Video_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uitzenden lukt niet`)
};

/**
* | output |
* | --- |
* | "Unable to broadcast" |
*
* @param {Video_FailedInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const video_failed = /** @type {((inputs?: Video_FailedInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_FailedInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_video_failed(inputs)
	if (locale === "ja") return ja_video_failed(inputs)
	if (locale === "zh") return zh_video_failed(inputs)
	if (locale === "es") return es_video_failed(inputs)
	if (locale === "pt") return pt_video_failed(inputs)
	if (locale === "id") return id_video_failed(inputs)
	if (locale === "fr") return fr_video_failed(inputs)
	if (locale === "tl") return tl_video_failed(inputs)
	if (locale === "vi") return vi_video_failed(inputs)
	if (locale === "ko") return ko_video_failed(inputs)
	if (locale === "de") return de_video_failed(inputs)
	if (locale === "ru") return ru_video_failed(inputs)
	if (locale === "tr") return tr_video_failed(inputs)
	if (locale === "it") return it_video_failed(inputs)
	if (locale === "pl") return pl_video_failed(inputs)
	if (locale === "uk") return uk_video_failed(inputs)
	if (locale === "hi") return hi_video_failed(inputs)
	if (locale === "ar") return ar_video_failed(inputs)
	if (locale === "ms") return ms_video_failed(inputs)
	if (locale === "bn") return bn_video_failed(inputs)
	if (locale === "zh-TW") return zh_tw2_video_failed(inputs)
	if (locale === "zh-HK") return zh_hk2_video_failed(inputs)
	if (locale === "ur") return ur_video_failed(inputs)
	if (locale === "fa") return fa_video_failed(inputs)
	if (locale === "sw") return sw_video_failed(inputs)
	if (locale === "nl") return nl_video_failed(inputs)
	return en_video_failed(inputs)
});